import produce from 'immer';
import {
    SET_ADMIN_NAV_OPTIONS,
    SET_HEADER_NAV_OPTIONS,
    SET_NAV_OPTIONS,
} from '../../actions/actionTypes';

export const initialOptions = {
    header: [
        {
            key: 'dashboard',
            translationKey: 'dashboard',
            url: '/',
        },
    ],
    admin: [
        {
            key: 'company_settings',
            translationKey: 'company_settings',
            url: '/entities/edit/',
        },
    ],
};

const navigationOptions = produce((draft, action = { type: null }) => {
    switch (action.type) {
        case SET_NAV_OPTIONS:
            return action.navOptions;
        case SET_ADMIN_NAV_OPTIONS:
            return {
                ...draft,
                admin: action.navOptions,
            };
        case SET_HEADER_NAV_OPTIONS:
            return {
                ...draft,
                header: action.navOptions,
            };
    }
}, initialOptions);

export default navigationOptions;
